module.exports = __webpack_public_path__ + "img/c-sgen_propagation.9b259716.webp";